import { apiClient } from '../utils/api';
import type { IdPhoto, IdPhotoSide } from '../components/camera/types';

interface ApiResponse<T> {
  success: boolean;
  message?: string;
  data?: T;
}

export async function listClientIdPhotos(clientId: string): Promise<IdPhoto[]> {
  const response = await apiClient(`/api/clients/${clientId}/id-photos`);
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.message || 'Failed to fetch client ID photos');
  }
  const data: ApiResponse<{ photos: IdPhoto[] }> = await response.json();
  return data.data?.photos ?? [];
}

export async function uploadClientIdPhoto(
  clientId: string,
  blob: Blob,
  side: IdPhotoSide,
): Promise<IdPhoto> {
  const formData = new FormData();
  formData.append('photo', blob, `id_${side}_${Date.now()}.jpg`);
  formData.append('side', side);

  const response = await apiClient(`/api/clients/${clientId}/id-photos`, {
    method: 'POST',
    body: formData,
  });

  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.message || 'Failed to upload client ID photo');
  }

  const data: ApiResponse<{ photo: IdPhoto }> = await response.json();
  if (!data.success || !data.data?.photo) {
    throw new Error(data.message || 'Failed to upload client ID photo');
  }
  return data.data.photo;
}

export async function deleteClientIdPhoto(clientId: string, photoId: string): Promise<void> {
  const response = await apiClient(`/api/clients/${clientId}/id-photos/${photoId}`, {
    method: 'DELETE',
  });

  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.message || 'Failed to delete client ID photo');
  }
}
